var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowsMediaPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Windows_Media_Player_48",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92 0 0 0.92 24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_MNLxqbSl0zCQ6lY6iqhZMa_1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -24 -24)",
    cx: 36.122,
    cy: 43.964,
    r: 42.34,
    fx: 36.122,
    fy: 43.964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(158,111,217)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "17.299999999999997%",
    style: {
      stopColor: "rgb(170,115,199)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.2%",
    style: {
      stopColor: "rgb(202,127,151)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(252,145,77)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_MNLxqbSl0zCQ6lY6iqhZMa_1)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 19
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_MNLxqbSl0zCQ6lY6iqhZMb_2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -24 -24)",
    cx: 14.976,
    cy: 6.898,
    r: 40.329,
    fx: 14.976,
    fy: 6.898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(75,75,75)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.1%",
    style: {
      stopColor: "rgb(57,57,57)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(37,37,37)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_MNLxqbSl0zCQ6lY6iqhZMb_2)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_MNLxqbSl0zCQ6lY6iqhZMc_3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -24 -24)",
    cx: 21.922,
    cy: 7.283,
    r: 45.662,
    fx: 21.922,
    fy: 7.283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(75,75,75)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.1%",
    style: {
      stopColor: "rgb(57,57,57)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(37,37,37)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_MNLxqbSl0zCQ6lY6iqhZMc_3)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-26, -24)",
    d: "M 20 17.127 L 20 30.872999999999998 C 20 31.548 20.752 31.950999999999997 21.314 31.575999999999997 L 31.624000000000002 24.702999999999996 C 32.126000000000005 24.367999999999995 32.126000000000005 23.630999999999997 31.624000000000002 23.295999999999996 L 21.314 16.422999999999995 C 20.752 16.049 20 16.452 20 17.127 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsMediaPlayer);
export default __webpack_public_path__ + "static/media/windows_media_player.08606acd19f0427cca2292aae7696888.svg";
export { ForwardRef as ReactComponent };